(function () {
  const MIN_REVIEW_COUNT = 15;
  const SYNC_INTERVAL_MS = 2000;
  const WATCH_DURATION_MS = 15000;

  function parseReviewCount(button) {
    if (!button) {
      return 0;
    }

    const ariaLabel = button.getAttribute('aria-label') || '';
    const ariaMatches = ariaLabel.match(/\d+\s+reviews?/gi);

    if (ariaMatches?.length) {
      return Number.parseInt(ariaMatches.at(-1), 10);
    }

    const reviewText = button.querySelector('.yotpo-sr-bottom-line-text');
    if (!reviewText) {
      return 0;
    }

    const textMatch = reviewText.textContent.match(/(\d[\d,]*)/);
    return textMatch ? Number.parseInt(textMatch[1].replace(/,/g, ''), 10) : 0;
  }

  function toggleElement(element, shouldShow) {
    if (!element) {
      return;
    }

    if (shouldShow) {
      element.style.removeProperty('display');
      return;
    }

    element.style.setProperty('display', 'none', 'important');
  }

  function updateReviewRow(reviewsRow) {
    const widget = reviewsRow.querySelector('.yotpo-reviews-star-ratings-widget');
    const button = widget?.querySelector('.yotpo-sr-bottom-line-button');

    if (!widget || !button) {
      return;
    }

    const reviewCount = parseReviewCount(button);
    const hasReviews = reviewCount > 0;
    const showReviewLabel = reviewCount >= MIN_REVIEW_COUNT;

    toggleElement(reviewsRow, hasReviews);

    const rightPanel = widget.querySelector('.yotpo-sr-bottom-line-right-panel');
    const divider = widget.querySelector('.yotpo-sr-vertical-border');
    const reviewText = widget.querySelector('.yotpo-sr-bottom-line-text');

    if (rightPanel) {
      toggleElement(rightPanel, showReviewLabel);
    } else {
      toggleElement(reviewText, showReviewLabel);
    }

    toggleElement(divider, showReviewLabel);
  }

  function updateAllReviewRows() {
    document.querySelectorAll('.product-item__reviews-row').forEach(updateReviewRow);
  }

  function watchForYotpo() {
    updateAllReviewRows();

    const observer = new MutationObserver(updateAllReviewRows);
    observer.observe(document.body, { childList: true, subtree: true });

    const intervalId = window.setInterval(updateAllReviewRows, SYNC_INTERVAL_MS);

    window.setTimeout(function () {
      observer.disconnect();
      window.clearInterval(intervalId);
    }, WATCH_DURATION_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForYotpo);
  } else {
    watchForYotpo();
  }
})();
